import React, { Component, Fragment } from "react";
import Banner from "./Banner";
import ExpertiseHomeBlock from "./ExpertiseHome";
import TreatmentImages from "./TreatmentImages";
import Counter from "./Counter";
import Testimonials from "./Testimonials";
import Workprocess from "./Workprocess";

class Content extends Component {
  render() {
    return (
      <Fragment>
        <Banner />
        <div
          className="section section-padding bg-cover bg-center bg-primary-1"
          style={{
            backgroundImage:
              "url(" + process.env.PUBLIC_URL + "/assets/img/pattern-3.png)",
            paddingTop: "90px",
          }}
        >
          <ExpertiseHomeBlock />
          <Counter />
        </div>
        <div className="section section-padding my-5 pb-3">
          <div className="text-center pt-5 pb-3 ">
            <h3 className="title" style={{ fontSize: "50px" }}>
              Personalized Solutions for Your Health Needs
            </h3>
          </div>
          <TreatmentImages />
        </div>
        <div
          className="relative style-5 bg-primary-1 pt-5 pb-4"
          style={{
            backgroundImage:
              "url(" + process.env.PUBLIC_URL + "/assets/img/pattern-2.png)",
          }}
        >
          <div
            style={{
              background: "#7aa836",
              height: "50px",
              width: "50px",
              position: "absolute",
              right: "calc(50% - 25px)",
              bottom: "-25px",
              rotate: "45deg",
              zIndex: "5",
            }}
          ></div>
          <div className="row justify-content-center style-5">
            <h2 className="text-white text-center">
              GET FREE 15 MINUTES PRE-ASSESSMENT
            </h2>
            <p
              className="text-white text-center"
              style={{ fontSize: "18px", maxWidth: "60%", fontWeight: "500" }}
            >
              Take control of your health today! Our free pre-assessment
              empowers you with personalized guidance, answers your questions,
              and ignites your healing journey. Book now!
            </p>
          </div>
        </div>
        <Workprocess />

        <Testimonials />
      </Fragment>
    );
  }
}

export default Content;
